import React from 'react';
import Routes from '../routes';
import '../assets/sass/main.scss';
import USER_API from '../services/userService/api';

class App extends React.Component {
  componentWillMount() {
    USER_API.authUser();
  }

  render() {
    return <Routes />;
  }
}

export default App;



// WEBPACK FOOTER //
// src/components/App.jsx